import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {createUserWithEmailAndPassword} from 'firebase/auth';
import { auth, database } from '../../../utils/firebase';
import { ref, set } from 'firebase/database';
import signup from './CreateAccount.module.css';
import account from "../AccountSettings/AccountSettings.module.css";

const SignUp = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const navigate = useNavigate();

    const handleSignUp = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            alert("Passwords do not match");
            return;
        }
        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const userId = userCredential.user.uid;
            await set(ref(database, `people/${userId}`), {
                nameFirst: firstName,
                nameLast: lastName,
                email: email,
                name: firstName + " " + lastName
            });
            navigate('/app');
        } catch (error) {
            alert(error.message);
        }
    };

    return (
        <div className={signup['signup-container']}>
            <div className={signup['signup-box']}>
                <h2>Sign Up</h2>
                <form onSubmit={handleSignUp}>
                    <div className={signup['form-group']}>
                        <label>First Name</label>
                        <input
                            type="text"
                            placeholder="Enter your first name"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            required
                        />
                    </div>
                    <div className={signup['form-group']}>
                        <label>Last Name</label>
                        <input
                            type="text"
                            placeholder="Enter your last name"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            required
                        />
                    </div>
                    <div className={signup['form-group']}>
                        <label>Email</label>
                        <input
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className={signup['form-group']}>
                        <label>Password</label>
                        <input
                            type="password"
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div className={signup['form-group']}>
                        <label>Confirm Password</label>
                        <input
                            type="password"
                            placeholder="Confirm your password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className={signup['btn-primary']}>Sign Up</button>
                </form>
            </div>
            <div className={signup['signup-footer']}>
                <button
                    onClick={() => navigate("/")}
                    className={account['text-link']}
                    style={{ background: "none", border: "none", color: "inherit", cursor: "pointer" }}
                >
                    Return to Home
                </button>
                <button
                    onClick={() => navigate("/auth/login")}
                    className={account['text-link']}
                    style={{ background: "none", border: "none", color: "inherit", cursor: "pointer" }}
                >
                    Log In
                </button>
            </div>
        </div>
    );
};

export default SignUp;